import type { CopyShape } from "@tami/core/intl";

import type { LOADING_INDICATOR_COPY_PT_BR } from "../loading-indicator.copy";

export const LOADING_INDICATOR_COPY_ES_ES: CopyShape<
  typeof LOADING_INDICATOR_COPY_PT_BR
> = { loading: "Cargando" };
